import request from '../utils/request';

// TODO: to be removed
export const getUserGroupsDetailedService = () => {
  return async dispatch => {
    const response = await dispatch(
      request('/users/user-groups', {
        method: 'GET',
      }),
    );
    const { data } = response;
    const result = {};
    if (data !== undefined) {
      data.forEach(userGroup => {
        result[userGroup.value] = userGroup.permission;
      });
    }
    
    response.data = result;
    return response;
  };
};

export const savePersonalDetailsService = (data, id = 0) => {
  if (id > 0) {
    const dataToSend = {
      ...data,
      id,
    };
    
    return async dispatch => {
      const response = await dispatch(
        request('/users/personal', {
          method: 'POST',
          data: dataToSend,
        }),
      );
      return response;
    };
  }
  return null;
};

export const saveSecurityDetailsService = (data, id = 0) => {
  if (id > 0) {
    const dataToSend = {
      ...data,
      id,
    };
    
    return async dispatch => {
      const response = await dispatch(
        request('/users/security', {
          method: 'POST',
          data: dataToSend,
        }),
      );
      return response;
    };
  }
  return null;
};

export const saveAvatarService = (data, id = 0) => {
  if (id > 0) {
    const dataToSend = {
      ...data,
      id,
    };
    
    return async dispatch => {
      const response = await dispatch(
        request('/users/avatar', {
          method: 'POST',
          data: dataToSend,
        }),
      );
      return response;
    };
  }
  return null;
};

export const getUserGroupsService = (value = '') => {
  return async dispatch => {
    const response = await dispatch(
      request('/users/user-groups', {
        method: 'GET',
        params: { value },
      }),
    );
    return response;
  };
};

export const saveUserGroupService = (dataToSend, id = 0) => {
  if (id > 0) {
    return async dispatch => {
      const response = await dispatch(
        request('/users/user-groups/' + id, {
          method: 'PUT',
          data: dataToSend,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/users/user-groups', {
        method: 'POST',
        data: dataToSend,
      }),
    );
    return response;
  };
};

export const deleteUserGroupsService = array => {
  return async dispatch => {
    const response = await dispatch(
      request('/users/user-groups', {
        method: 'DELETE',
        params: { id: array },
      }),
    );
    return response;
  };
};

export const saveUserService = (data, id = 0) => {
  if (id > 0) {
    // 
    return async dispatch => {
      const response = await dispatch(
        request('/users/' + id, {
          method: 'PUT',
          data,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/users', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const getUsersService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/users', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/users', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getUserByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/users/' + id, {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const deleteUsersService = array => {
  return async dispatch => {
    const response = await dispatch(
      request('/users', {
        method: 'DELETE',
        params: { id: array },
      }),
    );
    
    return response;
  };
};

export const getCurrentUser = () => {
  return async dispatch => {
    const resp = await dispatch(
      request('/users/current', {
        method: 'GET',
      }),
    );
    return resp;
  };
};
